import { render, staticRenderFns } from "./NewsConfig.vue?vue&type=template&id=7523d8ab&"
import script from "./NewsConfig.vue?vue&type=script&lang=ts&"
export * from "./NewsConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports